import { render } from "./index2.vue?vue&type=template&id=297d20ba&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"

import "./index2.vue?vue&type=style&index=0&id=297d20ba&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297d20ba"]])

export default __exports__